import drag_img from '../../../assets/images/drag.svg'
import { forwardRef } from "react";
import Folder from "../_components/Folder";

import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

export const DraggableFolder = (props) => {
  const sortable = useSortable({id: props.folder?.folder_id});
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition,
  } = sortable;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div className='draggable_folder' ref={setNodeRef} >
      <img src={drag_img} className="mx-auto d-block"{...attributes} {...listeners} />
      <Folder
        style={style}
        {...props}
      />
    </div>
    
  );
};


export const DraggableContainer = forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={className}>
        {children}
      </div>
    );
  }
); 

export function Grid({children, columns}) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        columnGap: 16,
        rowGap: 32,
        padding: 10,
      }}
    >
      {children}
    </div>
  );
}